// Model.js
// -----------------------
// @module Case
define("NVT.NewContactRegistration.NewContactRegistration.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/NewContactRegistration/SuiteScript2/NewContactRegistration.Service.ss"
            ),
            true
        )
});
});
